export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_kr-12b40b9d5c848450bbf4621a36490bbd.png";